import { useQuery, UseQueryResult } from "@tanstack/react-query";
import getAPI from "../services/api";

const useBatchHistory = ({
  page = 1,
  pageSize = 100,
  filters = {},
  sort = {},
}: {
  page?: number;
  pageSize?: number;
  filters?: any;
  sort?: any;
}): UseQueryResult<any> => {
  return useQuery(["batch-histories", page, pageSize, filters, sort], async () => {
    const api = await getAPI();
    const { data } = await api.get("/batch-histories", {
      params: {
        pagination: { pageSize, page },
        filters,
        sort,
      },
    });
    return data;
  });
};

export default useBatchHistory;
